import { AdminProductEditor } from '@/admin/AdminProductEditor';
import { loadCJ925PreviewProduct } from '@/services/cj925PreviewStore';
import { navigate } from '@/hooks/useRoute';

export function AdminCJ925PreviewEditor({productId}:{productId:number}){
 const product=loadCJ925PreviewProduct(productId);
 if(!product)return <div className="admin-content"><div className="admin-card"><h1>מוצר CJ925 לא נמצא</h1><button className="btn dark" onClick={()=>navigate('/admin/cj925-import')}>חזרה ל-CJ925 Import</button></div></div>;
 return <AdminProductEditor initialProduct={product} previewMode previewProductId={productId}/>;
}
